import { render, staticRenderFns } from "./ag_test_command_settings.vue?vue&type=template&id=560b7514&scoped=true&"
import script from "./ag_test_command_settings.vue?vue&type=script&lang=ts&"
export * from "./ag_test_command_settings.vue?vue&type=script&lang=ts&"
import style0 from "./ag_test_command_settings.vue?vue&type=style&index=0&id=560b7514&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "560b7514",
  null
  
)

export default component.exports